import {
  fetchAlerts,
  postAlertModal,
  deleteAlert,
  pausePlayAlert,
  modifyAlert,
  fetchTriggeredAlerts,
} from "../../services/backendAPI";

export const fetchAlertsAction = () => (dispatch) => {
  return fetchAlerts()
    .then((resp) => {
      const data = resp?.data || [];
      dispatch({ type: "SET_ALERTS", payload: Array.isArray(data) ? data : [] });
      return { status: "success", data };
    })
    .catch((err) => {
      dispatch({ type: "SET_ALERTS_ERROR_MESSAGE", payload: err?.message || String(err) });
      return { status: "error", message: err?.message || String(err) };
    });
};

export const postAlertModalAction = (alertsData) => async (dispatch) => {
  try {
    const { status, message } = await postAlertModal(alertsData);
    await dispatch(fetchAlertsAction());
    return { status, message };
  } catch (err) {
    return { status: "error", message: err?.message || String(err) };
  }
};

export const modifyAlertModalAction = (alert_id, alertsData) => async (dispatch) => {
  try {
    const { status, message } = await modifyAlert(alert_id, alertsData);
    await dispatch(fetchAlertsAction());
    return { status, message };
  } catch (err) {
    return { status: "error", message: err?.message || String(err) };
  }
};

export const deleteAlertAction = (id) => async (dispatch) => {
  try {
    const { status, message } = await deleteAlert(id);
    await dispatch(fetchAlertsAction());
    return { status, message };
  } catch (err) {
    return { status: "error", message: err?.message || String(err) };
  }
};

export const pausePlayAlertAction = (id, alertControl) => async (dispatch) => {
  try {
    const { status, message } = await pausePlayAlert(id, alertControl);
    await dispatch(fetchAlertsAction());
    return { status, message };
  } catch (err) {
    return { status: "error", message: err?.message || String(err) };
  }
};

export const fetchTriggeredAlertsAction = (clientId) => async (dispatch) => {
  try {
    const resp = await fetchTriggeredAlerts(clientId);
    const updates = resp?.data?.updates || resp?.data || [];
    dispatch({ type: "SET_TRIGGERED_ALERTS", payload: updates });
    const unseen = updates.filter((u) => u && u.view === false).length;
    dispatch({ type: "SET_UNSEEN_ALERTS", payload: unseen });
    return { status: "success", data: updates };
  } catch (err) {
    return { status: "error", message: err?.message || String(err) };
  }
};

export const resetUnseenAlerts = () => ({ type: "RESET_UNSEEN_ALERTS" });

export const addTriggeredAlert = (alert) => ({ type: "ADD_TRIGGERED_ALERT", payload: alert });

export const incrementUnseenAlerts = () => ({ type: "INCREMENT_UNSEEN_ALERTS" });

// Modal control — mirrors the openOrderWindow/closeOrderWindow pattern so the
// modal lives at App-level and survives the lifecycle of whatever triggered it.
export const openPriceAlertModal = ({ instrument, isModify = false, existingAlert = null }) => ({
  type: "OPEN_PRICE_ALERT_MODAL",
  payload: { instrument, isModify, existingAlert },
});

export const closePriceAlertModal = () => ({ type: "CLOSE_PRICE_ALERT_MODAL" });
